<template>
  <div class="card">
    <div class="section">
      <div class="section-title">
        <base-section-title title="监控到此风险的企业" />
      </div>
      <div class="section-content">
        <jczh-table-content
          :border="false"
          :show-index="false"
          :header-cell-style="{
            background: '#FAFAFA'
          }"
          :data="tableList"
          :option="tableConfig"
          pagination
          :total="total"
          :page.sync="page"
          :limit.sync="size"
          :pagination-props="{
            layout: 'total, prev, pager, next'
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'

// 后端api
import { setRiskReadListApi } from '@/api/risk/manage'

// 数据字典
import { riskWhetherReadDict } from '@/dictionary/risk'

// mixins
import listFilterMixin from '@/mixins/list-filter-mixin'

export default {
  name: 'RiskCompanyList',

  components: {
    BaseSectionTitle
  },

  mixins: [listFilterMixin],

  props: {
    orderMonitorId: {
      type: [Number, String],
      default: ''
    }
  },

  data() {
    return {
      // 表格数据
      total: 0,
      tableList: [],
      allList: []
    }
  },

  computed: {
    tableConfig() {
      return [
        { label: '企业名称', prop: 'riskCompanyName', minWidth: 150 },
        {
          label: '是否已查看该风险',
          prop: 'isRead',
          filter: value => riskWhetherReadDict.translate(value).label || ' - ',
          minWidth: 130
        }
      ]
    }
  },

  async mounted() {
    await this.getAllList()
    this.page = 1
    this.getList()
  },

  methods: {
    /**
     * 获取列表
     */
    getList() {
      this.tableList = this.allList.slice(
        (this.page - 1) * this.size,
        this.page * this.size
      )
    },

    async getAllList() {
      if (!this.orderMonitorId) {
        return
      }
      await setRiskReadListApi(this.orderMonitorId)
        .then(res => {
          this.allList = res.data || []
          this.total = (res.data || []).length
        })
        .catch(err => {
          this.$message.error(err.message || '获取列表失败')
        })
    }
  }
}
</script>

<style></style>
